import { AppRootContext } from './app-root-context.service'
import { TranslateService } from '@ngx-translate/core';
import { PlanetPortalApplication } from '@worktile/planet';
import { StaticProvider } from '@angular/core';

export interface PortalApplicationData {
    appRootContext: AppRootContext;
    translate: TranslateService;
}

export function getPortalTransmissionExtraProviders(): StaticProvider[] {
    const portalApp: PlanetPortalApplication<PortalApplicationData> = window['planet']['portalApplication']
    return [
        {
            provide: PlanetPortalApplication,
            useValue: portalApp
        },
        {
            provide: AppRootContext,
            useValue: portalApp.data.appRootContext
        },
        {
            provide: TranslateService,
            useValue: portalApp.data.translate
        }
    ];
}
